// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3va6q","unreadBadge":"styles_unreadBadge__1IX4r","modalContent":"styles_modalContent__1AYvF","modal":"styles_modal__2RBzz"};